import s from "./newItemAlert.module.css";
import {useBehavioralContext} from "../../../../../contexts";

const NewItemAlert = () => {
    const {newItemAlertStatus} = useBehavioralContext();

    // Prevents component from rendering if its isOpen status is set to false
    if (!newItemAlertStatus["isOpen"]) {
        return null;
    }

    return (
        <div className={`${s.root} ${newItemAlertStatus["isOpen"] ? s.fadeInAnimation : s.fadeOutAnimation}`}>
            <div className={s.content}>
                <div className={s.square}></div>
                <p className={`font-museo ${s.text}`}>
                    <span className={"font-bold"}>
                        {newItemAlertStatus["productName"]}
                    </span>
                    &nbsp;adicionada nas suas compras.
                </p>
            </div>
        </div>
    )
}

export default NewItemAlert;
